import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom, Observable } from 'rxjs';
import { JoinCostCenterCostUnitFacade } from '../../../../services/facades/master-data/join-cost-center-cost-unit.facade';
import { ISharedDataState } from '../../../../services/facades/master-data/shared-data-state.model';
import { SharedDataFacade } from '../../../../services/facades/master-data/shared-data.facade';

@Component({
    templateUrl: './transfer-cost-center-cost-unit-dialog.component.html',
    styleUrls: [ './transfer-cost-center-cost-unit-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransferCostCenterCostUnitDialogComponent implements OnInit {

    public sharedDataState$: Observable<ISharedDataState>;

    public formGroup = this.myFormBuilder.group({
        costAccountingTypeId: [ null as number, Validators.required ],
        targetCostAccountingTypeId: [ null as number, Validators.required ],
    }, { validators: this.sameValueValidator() });



    constructor(
        private myMatDialogRef: MatDialogRef<TransferCostCenterCostUnitDialogComponent>,
        private myCostCenterCostUnitFacade: JoinCostCenterCostUnitFacade,
        private mySharedDataFacade: SharedDataFacade,
        private myFormBuilder: FormBuilder,
    ) {
    }

    public ngOnInit(): void {
        this.sharedDataState$ = this.mySharedDataFacade.subState();
        void firstValueFrom(this.mySharedDataFacade.fetchCostAccountingTypes());
    }


    public async save(): Promise<void> {
        await this.myCostCenterCostUnitFacade.transferCostCenterCostUnit(this.formGroup.getRawValue());
        this.close();
    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private sameValueValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors => {
            const costAccountingTypeId = control.get('costAccountingTypeId')?.value;
            const targetCostAccountingTypeId = control.get('targetCostAccountingTypeId')?.value;

            if (costAccountingTypeId === targetCostAccountingTypeId) {
                return { sameValues: true };
            }

            return null;
        };
    }
}
